export const isPicksSpecificUrl = (url?: string | null) => {
    return url?.includes('picks/') || url?.includes('entry/');
};

export const isSbkSpecificUrl = (url?: string | null) => {
    return url?.includes('sbk/');
};
